<template>
  <el-menu
    :default-active="defaultActive"
    class="global-settings-nav"
    @open="handleOpen"
    @close="handleClose"
    @select="handleSelect"
    :router="router"
  >
    <component
      class="main-items"
      :is="item.subMenuItems ? 'el-submenu' : 'el-menu-item'"
      :key="item.index"
      v-for="(item, index) in items"
      :index="item.index || index.toString()"
      :route="item.route || null"
    >
      <template slot="title">
        <i v-if="item.icon" :class="item.icon"></i>
        <span>{{ item.title }}</span>
      </template>
      <component
        :is="subItem.subMenuItems ? 'el-submenu' : 'el-menu-item'"
        :class="subItem.subMenuItems ? 'second-submenu' : ''"
        :key="index + '-' + subIndex"
        v-for="(subItem, subIndex) in item.subMenuItems"
        :index="subItem.index || index + '-' + subIndex"
        :route="subItem.route || null"
      >
        <template slot="title">
          <span>{{ subItem.title }}</span>
          <i class="p-0 title-icon" :class="subItem.icon || 'empty-icon'"></i>
        </template>
        <el-menu-item
          :key="index + '-' + subIndex + '-' + subIndex2"
          v-for="(subItem2, subIndex2) in subItem.subMenuItems"
          :index="subItem2.index || index + '-' + subIndex + '-' + subIndex2"
          :route="subItem2.route || null"
        >
          <template slot="title">
            <span>{{ subItem2.title }}</span>
            <i class="p-0" :class="subItem2.icon || 'empty-icon'"></i>
          </template>
        </el-menu-item>
      </component>
    </component>
  </el-menu>
</template>
<script>
export default {
  name: 'GlobalSettingsNav',
  props: {
    handleSelect: {
      type: Function,
      default: () => {},
      required: false
    },
    handleOpen: {
      type: Function,
      default: () => {},
      required: false
    },
    handleClose: {
      type: Function,
      default: () => {},
      required: false
    },
    router: {
      type: Boolean,
      default: true,
      required: false
    },
    defaultActive: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      required: true,
      default: [
        {
          title: null,
          icon: 'el-icon-success',
          route: { path: '/' },
          index: 'homepage',
          subMenuItems: [
            // the same objects here
          ]
        }
      ]
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.global-settings-nav {
  border: 1px solid #dbdee7;
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  /deep/ .el-icon-empty-icon {
    margin-left: 3px;
    margin-right: 8px;
    background: #e6e6e6;
    border-radius: 8px;
    width: 16px;
    height: 16px;
    &.empty-icon {
      background: none;
    }
  }

  .second-submenu /deep/ .el-submenu__title {
    display: flex;
    justify-content: space-between;
    span {
      padding-left: 20px;
    }
    .title-icon {
      margin-top: 22px;
      font-size: 16px;
      margin-right: 0;
    }
    .el-submenu__icon-arrow {
      left: 40px;
      right: initial;
    }
  }

  .el-icon-success {
    color: #1fca10;
  }
  .el-icon-error {
    color: #f56c6c;
  }

  .el-icon-info {
    color: #909399;
  }

  .el-icon-warning {
    color: #e6a23c;
  }

  .main-items:not(:last-child) {
    box-shadow: inset 0 -1px 0 #f2f2f2;
  }

  .el-submenu .el-menu-item {
    min-width: auto;
  }
  /deep/ .el-submenu__title,
  .main-items,
  .main-items span,
  .el-menu-item span {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .el-menu-item.is-active {
    background: #e6f3fb;
  }

  .el-menu-item:not(.main-items) {
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
  }

  .el-menu-item:not(.main-items) i {
    margin-top: 18px;
    font-size: 16px;
    width: 14px;
    height: 14px;
    &.el-icon-empty-icon {
      margin-right: -1px;
    }
  }

  & /deep/ .el-menu--inline {
    border-bottom: none !important;
    padding: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/navigation/GlobalSettingsNav.vue